import { useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { filtersAtom } from 'services/filters/recoil';
import { FiltersState } from 'shared/types/common';

export function useSyncSearchFilters(filtersAtomData: FiltersState): void {
  const [filters, setFilters] = useRecoilState(filtersAtom);
  useEffect(() => {
    if (
      filtersAtomData &&
      JSON.stringify(filtersAtomData) !== JSON.stringify(filters)
    ) {
      setFilters(filtersAtomData);
    }
  }, [filters, filtersAtomData, setFilters]);
}
